enum DialogType {
  Error = 'error',
  Warning = 'warning',
  Success = 'success',
  Neutral = 'neutral',
  Destructive = 'destructive',
}

export default DialogType;
